import React, { useEffect, useState } from "react";
import api from "../api/axios";

function ProfitLoss() {
  const [tree, setTree] = useState([]);
  const [netProfitCM, setNetProfitCM] = useState(0);
  const [netProfitYTD, setNetProfitYTD] = useState(0);
  const [loading, setLoading] = useState(true);

  const [toDate, setToDate] = useState(
    new Date().toISOString().slice(0, 10)
  );

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
    ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
    : 0;

  /* ===============================
     Fetch Profit & Loss
  =============================== */
  const fetchProfitLoss = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/reports/profit-loss?branch_id=${branch_id}&to_date=${toDate}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setTree(res.data.current_month?.tree || []);
      setNetProfitCM(res.data.current_month?.net_profit || 0);
      setNetProfitYTD(res.data.year_to_date?.net_profit || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfitLoss();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB");
  };

  const getReportTitle = () => {
    return `Profit & Loss (Up to ${formatDate(toDate)})`;
  };

  /* ===============================
     Recursive Renderer (P/L Style)
  =============================== */
  const renderNode = (node, level = 1) => {
    const paddingLeft = `${level * 12}px`;

    const cm = Number(node.amount_cm ?? 0);
    const ytd = Number(node.amount_ytd ?? 0);

    /* ================= GROUP ================= */
    if (node.type === "group") {
      return (
        <React.Fragment key={`group-${node.group_id}`}>
          <tr className=""> {/* table-secondary */}
            <td style={{ paddingLeft }} className="fw-bold">
              {node.group_name}
            </td>
            <td className="text-end fw-bold">
              {Number(cm).toFixed(2)}
            </td>
            <td className="text-end fw-bold">
              {Number(ytd).toFixed(2)}
            </td>
          </tr>

          {node.children?.map((child) =>
            renderNode(child, level + 1)
          )}
        </React.Fragment>
      );
    }

    /* ================= LEDGER ================= */
    return (
      <tr key={`ledger-${node.ledger_id}`}>
        <td style={{ paddingLeft }}>
          <span className="text-muted me-2">
            {node.ledger_code}
          </span>
          {node.ledger_name}
        </td>
        <td className="text-end">
          {Number(cm).toFixed(2)}
        </td>
        <td className="text-end">
          {Number(ytd).toFixed(2)}
        </td>
      </tr>
    );
  };

  return (
    <>
      {/* Page Header */}
      <div className="row mb-3">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Profit & Loss</h4>
        </div>
      </div>

      {/* Filters */}
      <div className="row mb-3">
        <div className="col-md-3">
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <button
            className="btn btn-primary"
            onClick={fetchProfitLoss}
          >
            Show
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <h6 className="mb-4">{getReportTitle()}</h6>

              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm">
                    <thead className="table-light">
                      <tr>
                        <th>Particulars</th>
                        <th className="text-end">Current Month</th>
                        <th className="text-end">Year To Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {tree.length > 0 ? (
                        tree.map((node) => renderNode(node))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No data
                          </td>
                        </tr>
                      )}
                    </tbody>

                    {/* Net Profit / Loss */}
                    <tfoot className=""> {/* table-dark */}
                      <tr>
                        <th className="text-end">
                          Net {netProfitYTD < 0 ? 'Profit' : 'Loss'}
                        </th>
                        <th className="text-end">
                          {Number(netProfitCM ?? 0).toFixed(2)}
                        </th>
                        <th className="text-end">
                          {Number(netProfitYTD ?? 0).toFixed(2)}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfitLoss;